export default "__VITE_ASSET__DUR3_bU4__"